import { render } from "./CreateEventoModal.vue?vue&type=template&id=fd55f6c0&scoped=true"
import script from "./CreateEventoModal.vue?vue&type=script&lang=js"
export * from "./CreateEventoModal.vue?vue&type=script&lang=js"

import "./CreateEventoModal.vue?vue&type=style&index=0&id=fd55f6c0&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd55f6c0"]])

export default __exports__